import axios from 'axios';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  addVimeoVideoData
} = actions;

const {
  LOAD_VIMEO_VIDEO_DATA_SAGA,
  API_VIMEO_VIDEO_DATA
} = constants;

const apiLoadVideo = (uid) => (
  fetch(`${API_VIMEO_VIDEO_DATA}${uid}.json`).then(response => response.text()).then((json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      return [];
    }
  })
);

function* loadVimeoVideoDataSaga({ uid }) {
    try {
      const response = yield call(apiLoadVideo, uid);
      const videoData = (response || [])[0];
      yield put(addVimeoVideoData(uid, videoData));
    } catch (e) {}
}


function* __loadVimeoVideoDataSaga() {
  yield takeLatest(LOAD_VIMEO_VIDEO_DATA_SAGA, loadVimeoVideoDataSaga)
}

export {
  __loadVimeoVideoDataSaga,
};



/** WEBPACK FOOTER **
 ** ./src/sagas/vimeo.js
 **/